







































import { computed, defineComponent } from '@nuxtjs/composition-api';

import { CategoryTree, useMagentoConfiguration, useTax } from '~/composables';
import { APP_ROUTER_PATHS, PRINTERS_CATEGORY_UID } from '~/constants';
import { getCategoryNameForGtm, isPaperPage as isPaperCategory } from '~/helpers/categoryHelpers';
import isServer from '~/helpers/isServer';
import useUser from '~/modules/customer/composables/useUser';

import CategoryHeader from '../CategoryHeader.vue';
import NoProductsFound from '../NoProductsFound.vue';
import GroupedProductListing from './GroupedProductListing.vue';

export default defineComponent({
  components: {
    NoProductsFound,
    CategoryHeader,
    GroupedProductListing,
    CategoryFaq: () => import('../CategoryFaq.vue'),
    CategoryExpertReviews: () => import('../CategoryExpertReviews.vue'),
    CategoryDescription: () => import('../CategoryDescription.vue'),
    MyPrinters: () => import('~/modules/catalog/category/components/MyPrinters.vue'),
  },
  props: {
    category: {
      type: Object as () => CategoryTree,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  setup(props) {
    const { isAuthenticated } = useUser();
    const { getCalculatedPrice } = useTax();
    const { currentCurrencySymbol } = useMagentoConfiguration();

    const isParentHp = computed(() => props.category.name.includes('HP'));
    const isPaperPage = computed(() => isPaperCategory(props.category));
    const showMyPrinters = computed(() => isAuthenticated.value && !isPaperPage.value && process.env.VSF_IS_ENABLED_PRINTERS && !isServer);
    const groupName = computed(() => `${props.category.breadcrumbs?.[1]?.category_name || ''} ${props.category.name}`);
    const metaInfo = computed(() => {
      const fullCategoryName = props.category.breadcrumbs.length > 0
        ? `${groupName.value} ${props.category.breadcrumbs[0].category_name}` : '';

      if (props.category.products.items.length === 0) {
        return {};
      }

      // eslint-disable-next-line max-len
      const cheapestItem = props.category.products.items.reduce((prev, curr) => (getCalculatedPrice(prev.price.minimalPrice) < getCalculatedPrice(curr.price.minimalPrice) ? prev : curr));
      const cheapestPrice = getCalculatedPrice(cheapestItem.price.minimalPrice);

      return {
        title: props.category.level > 3 ? `Buy ${fullCategoryName} from ${currentCurrencySymbol.value}${cheapestPrice}` : props.category.meta_title,
      };
    });
    const categoryNameForGtm = computed(() => getCategoryNameForGtm(props.category.breadcrumbs));

    return {
      isParentHp,
      showMyPrinters,
      groupName,
      metaInfo,
      categoryNameForGtm,
      contactPath: APP_ROUTER_PATHS.contact,
      printersUid: PRINTERS_CATEGORY_UID,
    };
  },
  head() {
    return this.metaInfo;
  },
});
